module.exports = __webpack_public_path__ + "47a03ac7b261d9b6ebab595785317437.jpg";